export {Sticker} from './sticker';